import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Drying extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_bud_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Drying
        </h2>
        <p>
        <span className="highlight">Timeline: 5 days to 2 weeks.</span>
        </p>
        <p>
        To dry your freshly harvested bud, hang them upside down in a dark, well-ventilated room. You can use string to hang your plant, although binder clips work great as well. Keeping the humidity around the 45% - 55% range will allow your buds to dry, but keep them from drying too quickly. It's good to have air circulation in the drying area, but it's recommended that no air is being blown directly over the buds to prevent them from drying too quickly.
        </p>
        <p>
        You’ll know your plants are ready to cure when the smaller stems become dry enough that you can easily snap them in half.
        </p>
        <h3>
        Trimming
        </h3>
        <p>
        Once your plant is dry it’s time to move it to jars for curing. Carefully cut the buds off the stem, making sure you don’t damage the actual buds. Now cut off any remaining leaves from your bud. A good pair of spring loaded trimming scissors is your best friend. Wear rubber gloves while trimming and try not to touch or pinch them at anytime. 
        </p>
        <GuideButton slugTo="curing" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_drying.js